import { useState } from 'react'

const usePageController = () => {
  const pageUrl = window.location.pathname.split('/')[1]
  const [pageController, setPageController] = useState({
    mainPage: pageUrl === '',
    collections:
      pageUrl.includes('collections') || pageUrl.includes('collection'),
    courses: pageUrl.includes('courses'),
  })

  const updatePageController = () => {
    setPageController({
      mainPage: pageUrl === '',
      collections:
        pageUrl.includes('collections') || pageUrl.includes('collection'),
      courses: pageUrl.includes('courses'),
    })
  }

  const showUpgrade =
    pageUrl !== 'mini-course' && window.CONSTANTS.USER_ROLE_ID === 1

  return { pageController, updatePageController, showUpgrade }
}

export default usePageController
